export default function formatRoutesPaths(routes) {
  return routes.map(route => {
    if (!route.path.endsWith('/')) {
      if(route.path) {
        route.path += '/'
      }
    }

    // if(!route.path.startsWith('/')) {
    //   route.alias = '/' + route.path
    // } else {
    //   route.alias = route.path
    // }


    // if (isRoot && !route.path.startsWith('/')) {
    //   if(route.path) {
    //     route.path = '/' + route.path
    //   }
    // }

    if (!route.pathToRegexpOptions) {
      route.pathToRegexpOptions = {strict: true}
    }

    return route
  })
}
